import { render, staticRenderFns } from "./UserDataTabs.vue?vue&type=template&id=29967935&"
import script from "./UserDataTabs.vue?vue&type=script&lang=js&"
export * from "./UserDataTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports